import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FeatureGroup, Map, Marker, divIcon, latLng, marker, tileLayer } from 'leaflet';
import { clone } from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { FlagService } from '../../flag/flag.service';
import { ImgAjaxComponent } from '../../shared/_components/img-ajax/img-ajax.component';
import { AddFlagComponent } from '../add.flag/add.flag.component';
import { EditFlagComponent } from '../edit.flag/edit.flag.component';
import { PictureViewerComponent } from '../picture-viewer/picture-viewer.component';
import { PictureService } from '../picture.service';

@Component({
  selector: 'app-inspection-popup',
  templateUrl: './inspection-popup.component.html',
  styleUrls: ['./inspection-popup.component.scss'],
})
export class InspectionPopUpComponent implements OnInit {
  public get currentPicture() {
    return this._currentPicture;
  }
  public set currentPicture(value) {
    this._currentPicture = value;
    this.updateCurrentFlags();
  }

  constructor(
    private toastr: ToastrService,
    private flagService: FlagService,
    public pictureService: PictureService,
  ) {
    setInterval(() => {
      try {
        (window.opener as any).getPopupReference(window);
      } catch (e) {}
    }, 1000);
    this.setFlexValues();
  }

  get pictures() {
    const a = this.answer;
    if (!a) {
      return [];
    }
    if (Array.isArray(a)) {
      return a.reduce((acc: any[], ans: any) => [...acc, ...(ans.pictures || [])], []);
    }
    return a.pictures || [];
  }

  answer: any;

  currentFlags: any[];
  _currentPicture;
  hasPictures = true;

  map: Map = null;
  lOptions = {} as any;
  lLayers: any[] = [];
  markers = new FeatureGroup();
  flagsWithTooltip = [];

  showFlags = false;
  iconStyle = '0';
  flexValue = '7';
  rightColumnFlexValue = '3';
  updateImage = 0;
  showMapViewer = true;
  placeholderFlag;
  @Output() close = new EventEmitter();

  @ViewChild('image', { static: false }) image: ElementRef;
  @ViewChild('info', { static: false }) info: ModalDirective;
  @ViewChildren('imagefull') imagefull: QueryList<ElementRef>;
  @ViewChildren('thumb') thumbs: QueryList<ImgAjaxComponent>;
  @ViewChildren('viewerFull') viewerFull: QueryList<PictureViewerComponent>;
  @ViewChild('addFlagModal', { static: false }) addFlagModal: AddFlagComponent;
  @ViewChild('editFlagModal', { static: false }) editFlagModal: EditFlagComponent;

  ngOnInit() {
    window.addEventListener('message', this.receiveMessage.bind(this), false);
    this.currentPicture = 0;
    this.lOptions = { zoom: 15, center: latLng(32.963572, -95.302534) };
  }

  initMap() {
    this.markers = new FeatureGroup();
    this.lLayers = [
      tileLayer(`https://{s}.google.com/vt/lyrs=s,h,m&x={x}&y={y}&z={z}`, {
        maxZoom: 20,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        attribution: 'Google maps',
      }),
      this.markers,
    ];
  }

  private answerKey(a: any): string {
    if (!a) {
      return '';
    }
    if (Array.isArray(a)) {
      return a.map((x: any) => x.id).join(',');
    }
    return String(a.id);
  }

  receiveMessage(event) {
    if (!event.data || !('answer' in event.data)) {
      return;
    }
    const incoming = event.data.answer;
    if (this.answer && this.answerKey(this.answer) === this.answerKey(incoming)) {
      return;
    }

    this.hasPictures = event.data.hasPictures;
    this.answer = incoming;
    this._currentPicture = 0;
    this.initMap();
    this.updateCurrentFlags();
  }

  checkCoordinates() {
    return false;
  }

  unpinnedFlagsCount() {
    const answer = this.answer;
    if (!answer) {
      return 0;
    }
    if (Array.isArray(answer)) {
      return answer.reduce((n, a) => n + (a.flags || []).filter(flag => !flag.pictureId).length, 0);
    }
    return (answer.flags || []).filter(flag => !flag.pictureId).length;
  }

  /** Single Answer that owns the current picture (repeat questions use Answer[] on this.answer). */
  getAnswerForCurrentPicture() {
    const pic = this.pictures[this.currentPicture];
    if (!pic || !this.answer) {
      return this.answer;
    }
    if (Array.isArray(this.answer)) {
      return this.answer.find((a: any) => a.id === pic.answerId) || this.answer[0];
    }
    return this.answer;
  }

  getAnswerOwningFlag(flag: any) {
    if (!this.answer) {
      return null;
    }
    if (Array.isArray(this.answer)) {
      return this.answer.find((a: any) => a.id === flag.answerId) || this.answer[0];
    }
    return this.answer;
  }

  async flagPinned(flag) {
    const coord = this.viewerFull.first.imgSize;
    if (coord) {
      const picture = clone(this.pictures[this.currentPicture]);
      delete picture.answer;

      flag.picture = picture;
      flag.pictureId = flag.picture.id;
      flag.x = coord[0] / 2;
      flag.y = coord[1] / 2;

      this.flagsWithTooltip.push(flag.id);

      this.currentFlags = [...this.currentFlags, flag];

      await this.flagService.edit(flag.id, { ...flag });
      this.toastr.success('Flag Saved');
      this.updateCurrentFlags();
    }
  }

  formattedDateTime(date) {
    const obj = new Date(date);
    return `${obj.getMonth() + 1}/${obj.getDate()}/${obj.getFullYear()} ${obj.getHours() < 10 ? '0' : ''}${obj.getHours()}:${obj.getMinutes() < 10 ? '0' : ''}${obj.getMinutes()}`;
  }

  next() {
    if (this.hasNext()) {
      this.currentPicture++;
    }
  }

  prev() {
    if (this.currentPicture > 0) {
      this.currentPicture--;
    }
  }

  toggleFlags() {
    this.showFlags = !this.showFlags;
    this.updateImage += 1;
  }

  closeFlags() {
    this.showFlags = null;
    this.iconStyle = '0';
    this.updateImage += 1;
  }

  hasNext() {
    return this.currentPicture < this.pictures.length - 1;
  }

  showInfo() {
    this.info.show();
    console.log(window.opener);
  }

  closeInfo() {
    this.info.hide();
  }

  // tslint:disable:forin

  onMapReady(map: Map) {
    this.map = map;
  }

  getMapPoints() {
    return [];
  }

  centerMap() {
    this.map.fitBounds(this.markers.getBounds().pad(0.2));
  }

  private point(color) {
    const myCustomColour = color;

    // tslint:disable-next-line: max-line-length
    const markerHtmlStyles = `background-color: ${myCustomColour}; width: 1.5rem; height: 1.5rem; display: block; left: -0.75rem; top: -0.75rem; position: relative; border-radius: 3rem 3rem 0; transform: rotate(45deg); border: 1px solid #FFFFFF`;

    const icon = divIcon({
      className: 'my-custom-pin',
      iconAnchor: [0, 24],
      popupAnchor: [0, -36],
      html: `<span style="${markerHtmlStyles}" />`,
    });

    return icon;
  }

  private closePopups() {
    const pops = document.getElementsByClassName('leaflet-popup-close-button');
    for (let i = 0; i < pops.length; i++) {
      (pops[i] as any).click();
    }
  }

  answerChange(ev) {
    (window.opener as any).answerChange(this.answer);
  }

  addFlag(coords) {
    this.placeholderFlag = coords;
    this.addFlagModal.show({
      answer: this.getAnswerForCurrentPicture(),
      picture: this.pictures[this.currentPicture],
      coords,
      confirmed: () => {
        this.toastr.success('Flag Saved');
        this.placeholderFlag = undefined;
        this.updateCurrentFlags();
        this.answerChange(this.answer);
      },
      canceled: () => {
        this.placeholderFlag = undefined;
      },
    });
  }

  async moveFlag({ flag, x, y }) {
    const ans = this.getAnswerOwningFlag(flag);
    const newFlag = (ans.flags || []).find(f => f.id === flag.id);
    const original = ans.flags.find(f => f.id === newFlag.id);
    original.x = x;
    original.y = y;

    const updatedAnswer = await this.flagService.edit(flag.id, { ...flag, x, y });
    ans.pictures.forEach(p => {
      const updatedPicture = updatedAnswer.pictures.find(up => up.id === p.id);
      if (updatedPicture) {
        p.updatedAt = updatedPicture.updatedAt;
      }
    });
    this.toastr.success('Flag Saved');
    this.answerChange(this.answer);
    await this.updateCurrentFlags();
    // Remove moved flag
    if (this.flagsWithTooltip.length > 0) {
      this.flagsWithTooltip = this.flagsWithTooltip.filter(f => f !== flag.id);
    }
  }

  editFlag({ flag, clientX, clientY }) {
    const ans = this.getAnswerOwningFlag(flag);
    this.editFlagModal.show({
      flag,
      answer: ans,
      coords: { clientX, clientY },
      changed: newFlag => {
        const original = ans.flags.find(f => f.id === newFlag.id);
        original.text = newFlag.text;
        original.subtype = newFlag.subtype;
        original.subtypeId = newFlag.subtypeId;
        original.picture = newFlag.picture;
        original.pictureId = newFlag.pictureId;
        original.score = newFlag.score;
        original.groupId = newFlag.groupId;
        this.toastr.success('Flag Saved');
        this.answerChange(this.answer);
        this.updateCurrentFlags();
      },
      deleted: () => {
        ans.flags.splice(
          ans.flags.findIndex(f => f.id === flag.id),
          1,
        );
        this.toastr.success('Flag Removed');
        this.answerChange(this.answer);
        this.updateCurrentFlags();
      },
    });
  }

  async markupChanged() {
    this.answerChange(this.answer);
  }

  async updateCurrentFlags() {
    if (!this.pictures || !this.pictures[this.currentPicture]) {
      return;
    }
    this.currentFlags = await this.pictureService.getFlags(this.pictures[this.currentPicture].id);
  }

  setFlexValues() {
    const minFlexValue = 6.5;
    const minRightColumnFlexValue = 3.5;

    const maxFlexValue = 8.3;
    const maxRightColumnFlexValue = 1.7;

    const minWidth = 1300;
    const maxWidth = 2800;

    if (window.innerWidth > maxWidth) {
      this.flexValue = maxFlexValue.toString();
      this.rightColumnFlexValue = maxRightColumnFlexValue.toString();
    } else if (window.innerWidth < minWidth) {
      this.flexValue = minFlexValue.toString();
      this.rightColumnFlexValue = minRightColumnFlexValue.toString();
    } else {
      const t = (window.innerWidth - minWidth) / (maxWidth - minWidth);
      this.flexValue = (minFlexValue + t * (maxFlexValue - minFlexValue)).toString();
      this.rightColumnFlexValue = (
        minRightColumnFlexValue +
        t * (maxRightColumnFlexValue - minRightColumnFlexValue)
      ).toString();
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.target === document.body) {
      switch (event.key) {
        case 'ArrowLeft':
          this.prev();
          break;
        case 'ArrowRight':
          this.next();
          break;
        case 'Escape':
          this.closeFlags();
          break;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setFlexValues();
  }
}
